import ApplicationLayout from '@rio-cloud/rio-uikit/ApplicationLayout';

import AdminMenuList from '../features/adminMenu/AdminMenuList';
import RouteUpdater from '../routes/RouteUpdater';

import './App.css';

const AppLayout = () => (
    <ApplicationLayout data-testid='app-layout' className='bg-white'>
        <AdminMenuList />
        <RouteUpdater />
    </ApplicationLayout>
);

export default AppLayout;
